// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const SortWrapper = styled.p<{
  isDark: boolean;
  asc?: boolean;
  desc?: boolean;
}>(
  ({ theme, isDark, asc, desc }) => css`
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    width: fit-content;

    svg {
      position: absolute;
      left: 100%;
      path {
        fill-opacity: 1;
      }
      ${
        asc || desc
          ? css`
            path {
              ${
                asc
                  ? css`
                    &:nth-child(1) {
                      fill: ${theme.colors.gray['dark-70']};
                    }
                    &:nth-child(2) {
                      fill: ${
                        isDark ? theme.colors.white : theme.colors.base.dark
                      };
                    }
                  `
                  : css`
                    &:nth-child(1) {
                      fill: ${
                        isDark ? theme.colors.white : theme.colors.base.dark
                      };
                    }
                    &:nth-child(2) {
                      fill: ${theme.colors.gray['dark-70']};
                    }
                  `
              }
            }
          `
          : css`
            path {
              fill: ${theme.colors.gray['dark-70']};
            }
          `
      }
    }
  `,
);
